<template lang="pug">
	.easy-creative--settings--color-scheme
		.flex-col.space-large
			.flex-col.space-medium
				.font-lg.grey.upper {{$tCaption('Color scheme')}}
				.scheme-color.flex-col(v-for="settingVar in Object.keys(info.brandingVars)")
					.font-small.upper.grey {{settingVar}}
					.flex-row.align-center.space
						DxColorBox(:value="info.brandingVars[settingVar]", stylingMode="filled", @value-changed="e => $onColorChange(e, settingVar)", applyValueMode="instantly")
						.adt-button.clickable.hoverable.flex-row.align-center.center.padded-lg.rounded(v-if="info.brandingVars[settingVar] != info.defaultBranding[settingVar]", :title="$tCaption('Revert to default')",
							@click="onColorChange({ value: info.defaultBranding[settingVar] }, settingVar)")
							fas(icon="rotate-left")
</template>

<script>
	import _ from 'lodash';
	import DxColorBox from 'devextreme-vue/color-box';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative-settings--color-scheme',
		props: ['info'],
		components: {
			DxColorBox
		},
		data() {
			return {
				visible: false
			};
		},
		computed: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeSettingsColorScheme = this;
			this.$onColorChange = _.debounce(this.onColorChange, 100, {
				leading: false,
				trainling: true,
				maxWait: 400
			});
		},
		destroyed() {
			delete this.$onColorChange;
		},
		methods: {
			onColorChange(e, settingVar) {
				if (__DEBUG__)
					console.debug('onColorChange', { e, settingVar });
				this.$set(this.info.branding.JsonConfig, settingVar, e.value);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--settings--color-scheme {
	}
</style>
